
<!-- User / Visitor chooser -->
@if (isExploitant) {
  <div class="row">
    <div class="col-12">
      <label class="form-label">{{ 'services.craning.booking.form.debtorType' | translate }}*</label>
      <div>
        <div class="btn-group" role="group">
          <input class="btn-check" type="radio"
            [formControl]="debtorType"
            [value]="DebtorType.Customer">
            <label class="btn btn-toggle btn-toggle-left h-auto"
              [for]="debtorType"
              [ngClass]="{ active: debtorType.value === DebtorType.Customer }"
              translate="services.craning.booking.form.debtorTypes.user"
              (click)="changeDebtorType(DebtorType.Customer)"
            (keyup)="changeDebtorType(DebtorType.Customer)"></label>
            <input class="btn-check" type="radio"
              [formControl]="debtorType"
              [value]="DebtorType.Visitor">
              <label class="btn btn-toggle btn-toggle-right h-auto"
                [for]="debtorType"
                [ngClass]="{ active: debtorType.value === DebtorType.Visitor }"
                translate="services.craning.booking.form.debtorTypes.visitor"
                (click)="changeDebtorType(DebtorType.Visitor)"
              (keyup)="changeDebtorType(DebtorType.Visitor)"></label>
            </div>
          </div>
          <app-form-error [control]="debtorType"></app-form-error>
        </div>
      </div>
    }

    <!-- User Search field -->
    @if (isExploitant && debtorType.value === DebtorType.Customer && debtorType.enabled) {
      <div class="row mt-4">
        <div class="col-12">
          <app-search-customer #searchCustomerComponent ngDefaultControl
            [customerContact]="customerContact"
          (selectedCustomerEvent)="setSelectedCustomer($event)"></app-search-customer>
        </div>
      </div>
    }

    <!-- User Summary -->
    @if (debtorType.value === DebtorType.Customer && customerContact) {
      <app-customer-visitor-summary
        [isExploitant]="isExploitant"
      [visitor]="customerContact"></app-customer-visitor-summary>
    }

    <!-- Visitor form -->
    @if (debtorType.value === DebtorType.Visitor) {
      <div class="row">
        <div class="col-12">
          <app-customer-data-form [contactForm]="visitorContactForm"
          [visitorContactDto]="visitor"></app-customer-data-form>
        </div>
      </div>
    }
